import { render, staticRenderFns } from "./RecentItemsList.vue?vue&type=template&id=549c273c&"
import script from "./RecentItemsList.vue?vue&type=script&lang=js&"
export * from "./RecentItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports